<template>
    <b-modal
        :id="'watch-module-motivation-modal-' + dateIn.id"
        :title="moduleIn && moduleIn.title"
        :ok-title="$t('modules.register')"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="lg"
        modal-class="apprentice-default-modal">
        <div>
            <b-form-textarea
                class="apprentice-textarea"
                id="module-motivation-textarea"
                v-model="motivation"
                :placeholder="$t('modules.fill_in_your_motivation_here_if_necessary')"
                rows="5">
            </b-form-textarea>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-module-show-module-motivation-modal-component',
    props: {
        moduleIn: Object,
        dateIn: Object,
    },
    data() {
        return {
            motivation: '',
        };
    },
    methods: {
        save() {
            this.$emit('check-date', this.dateIn);

            let data = {
                module_id: this.moduleIn.id,
                module_date_id: this.dateIn.id,
                motivation: this.motivation,
            };

            if (!this.error) {
                this.alert.saving();
                this.axios.post(this.routes.addModuleUser(), data).then(
                    (response) => {
                        for (const date of this.moduleIn.module_dates) {
                            if (date.id === this.dateIn.id) {
                                date.addRelation('module_users', response.data);
                                this.moduleIn.attach('module_users', response.data.id);
                            }
                        }

                        this.$emit('update-signed-user', response.data);
                        this.$bvModal.hide('watch-module-motivation-modal-' + this.dateIn.id);
                        this.$bvModal.hide('watch-module-modal');

                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped></style>
